import { isNil } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useRequestResetPasswordMutation } from '../../apis/mlkApi/mlk.api.hooks';
import { parseRes } from '../../apis/utils';
import { Button } from '../../components/Button/Button';
import { BaseLayout } from '../../components/Layout/Layout';
import { useBack } from '../../hooks/useBack';
import { useResendEmailTimer } from '../../hooks/useResendEmailTimer';
import { useLanguage } from '../../locale/useLanguage';
import { Routes } from '../../routes/types';

import './ForgetPasswordCheckEmailView.css';

type ForgetPasswordCheckEmailViewProps = {};

type ForgetPasswordCheckEmailViewRouteState = {
  email?: string;
};

export const ForgetPasswordCheckEmailView: React.FC<
  ForgetPasswordCheckEmailViewProps
> = () => {
  const [t] = useLanguage();
  const goBack = useBack();
  const history = useHistory();
  const location = useLocation<
    ForgetPasswordCheckEmailViewRouteState | undefined
  >();

  const [resendFulfilledTimestamp, setResendFulfilledTimestamp] =
    useState<number>();

  const { isResendActive, remainingTime } = useResendEmailTimer(
    resendFulfilledTimestamp
  );
  const [requestResetPassword] = useRequestResetPasswordMutation();

  useEffect(() => {
    if (isNil(location.state?.email)) {
      history.replace(Routes.RecoverPasswordInsertEmail);
    }
  }, [history, location.state?.email]);

  const resendEmail = useCallback(() => {
    requestResetPassword(location.state!.email!).then((res) => {
      const { successRes, errorRes } = parseRes(res);
      if (successRes.data) {
        setResendFulfilledTimestamp(+new Date());
      }

      if (errorRes.error) {
        // TODO: Handle API error
      }
    });
  }, [location.state, requestResetPassword]);

  return (
    <BaseLayout
      onBackClick={goBack}
      hasBack
      title={t('pageTitles.checkEmailPasswordRecovery')}
    >
      <div className="forget-password-check-email--body">
        <div>
          <h2 className="forget-password-check-email--title">
            {t('checkEmailPasswordRecovery.title')}
          </h2>
          <p className="forget-password-check-email--description">
            {t('checkEmailPasswordRecovery.description')}
          </p>
          <p className="forget-password-check-email--user-email">
            {location.state?.email}
          </p>
        </div>
        <div className="forget-password-check-email--button-container">
          <Button
            isDisabled={!isResendActive}
            onClick={resendEmail}
            label={t('checkEmailPasswordRecovery.emailNotReceived')}
          />
          <div className="forget-password-check-email--timer-container">
            {!isResendActive && (
              <p>
                {t('checkEmailPasswordRecovery.retryDescription', {
                  remainingTime: remainingTime,
                })}
              </p>
            )}
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};
